import type { Progress } from './prefs.svelte';

/** Resume what this browser actually watched, not an invented recommendation. */
export function resumeItems(items: readonly Progress[], limit = 8): Progress[] {
  return items.filter(p => !p.finished && p.positionSec >= 30 && p.durationSec > 0)
    .slice().sort((a, b) => b.updatedAt - a.updatedAt).slice(0, limit);
}
export const DISCOVERY_COLLECTIONS = ['sitcoms', 'mind-benders', 'heists', 'ghibli'];
